// Added by - Jhamman Lal Sahu on 17-08-2024
// Reason - UI to render Terms and conditions details

import React, { useEffect, useState, useContext } from "react";
import Style from "../pages/TermsAndConditions/TermsAndConditions.module.css";
import {
  getSocialIconsApi,
  termsAndConditionsDetailsApi,
} from "../Api/services";
import parse from "html-react-parser";
import { GlobalContext } from "../context/Context";
import NavigationPath from "../components/NavigationPath/NavigationPath";
import { baseURL } from "../Api/config";
import { Link, useNavigate } from "react-router-dom";

const SocialIconDetails = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [socialIconData, setSocialIconData] = useState({});

  //Added by Jhamman Lal sahu on 17-08-2024
  //Reason - API call to get Terms And Conditions details

  const fetchSocialIconData = async () => {
    try {
      const response = await getSocialIconsApi();
      setSocialIconData(response.social_icon_details);
    } catch (error) {
      console.error("Error fetching homepage details:", error);
    }
  };

  useEffect(() => {
    /**
     * Added by - Jhamman lal sahu on 18-09-2024
     * Reason - Scroll to top when refresh
     */
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    /**
     * End of addition by - Jhamman lal sahu on 18-09-2024
     * Reason - Scroll to top when refresh
     */

    /**
     * Added by - Jhamman lal sahu on 17-08-2024
     * Reason - To add paths to navigation path variable
     */
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Social Media Details", path: "/socialicons" },
    ]);
    /**
     * End of code addition by - Jhamman lal sahu on 17-08-2024
     * Reason - To add paths to navigation path variable
     */

    fetchSocialIconData();
  }, []);

  //End of the addition by Jhamman Lal sahu on 17-08-2024
  //Reason - API call to get terms and conditions details

  if (!socialIconData) return <p>No details available</p>;

  return (
    <div className={Style.mainContainer}>
      <div className={Style.subContainer}>
        <NavigationPath navigationPathArray={navigationPath} />

        {socialIconData?.length > 0 ? (
          <div
            className={
              socialIconData.length === 1
                ? Style.singleImage
                : Style.container
            }
          >
            {socialIconData.map((icon, index) => (
              <Link key={index} to={icon.link} target="_blank">
                <img
                  src={baseURL + icon.logo}
                  className={Style.image}
                  alt={`social-icon-${index}`}
                />
              </Link>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SocialIconDetails;

// End of the addition by Jhamman Lal Sahu on 17-08-2024
// Reason - UI to render Terms And Conditions details
